// src/component/footer/index.jsx

import React, { useEffect, useState, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Crown from "../../asserts/crown.png";
import Phone from "../../asserts/system-regular-58-call-phone.gif";
import Mail from "../../asserts/wired-outline-177-envelope-send.gif";
import Facebook from "../../asserts/facebook.png";
import Insta from "../../asserts/instagram.png";
import YouTube from "../../asserts/youtube.png";
import { axiosInstance } from "../Api/instance";
import Logo from "../../asserts/Artboard 2.png";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../../Context";
import DownloadIcon from "@mui/icons-material/Download";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import "./index.css";

const FooterWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: '#0B0F19', // Dark clinical background
  borderTop: `1px solid ${theme.palette.divider}`,
  color: '#9CA3AF', // slate 400
  padding: '64px 0 24px 0',
  fontFamily: 'var(--font-family)',
}));

const FooterLink = styled(NavLink)({
  color: '#9CA3AF',
  textDecoration: 'none',
  fontSize: '0.875rem',
  transition: 'color 0.15s ease',
  '&:hover': {
    color: '#FFFFFF',
  },
});

const AnchorLink = styled('a')({
  color: '#9CA3AF',
  textDecoration: 'none',
  fontSize: '0.875rem',
  transition: 'color 0.15s ease',
  '&:hover': {
    color: '#FFFFFF',
  },
});

const PremiumBanner = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #1E3A8A 0%, #0F172A 100%)',
  borderRadius: '20px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  border: '1px solid #1F2937',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
}));

const SocialIconLink = styled('a')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '36px',
  height: '36px',
  borderRadius: '10px',
  backgroundColor: '#1F2937',
  color: '#9CA3AF',
  transition: 'transform 0.15s ease, background-color 0.15s ease, color 0.15s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    backgroundColor: '#374151',
    color: '#FFFFFF',
  },
});

export default function Footer() {
  const [data, setData] = useState([]);
  const { Endpoint } = useContext(UserContext);
  const email = localStorage.getItem("userMail");
  const Navigate = useNavigate();
  const location = useLocation();

  const getHref = (path) => {
    return location.pathname === "/home" ? `#${path}` : `/home/#${path}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.post(`get/U_ViewStaticInfo.php`, {
          userId: email,
        });
        if (response.status === 200) {
          if (response.data.message === "timeout") {
            Navigate("/signin");
            return;
          }
          setData(Array.isArray(response.data) ? response.data : []);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [email, Endpoint, Navigate]);

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = "/app-release.apk";
    link.download = "NursingUpdate.apk";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <FooterWrapper>
      <Container>
        <Row style={{ marginBottom: '40px', gap: '24px xl-0' }}>
          
          {/* Logo & Description */}
          <Col xs={12} md={4} style={{ marginBottom: '24px' }}>
            <Box style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
              <img src={Logo} alt="" height="40px" width="40px" style={{ objectFit: 'contain' }} />
              <Typography variant="h3" style={{ color: '#FFFFFF', fontWeight: 800 }}>
                Nursing Update
              </Typography>
            </Box>
            <Typography variant="body1" style={{ color: '#9CA3AF', fontSize: '0.875rem', lineHeight: 1.6, marginBottom: '20px' }}>
              A premium, comprehensive MCQ mock examination engine and LMS portal configured for medical nursing students preparing for competitive licensing examinations.
            </Typography>
            <Button
              variant="contained"
              onClick={handleDownload}
              startIcon={<DownloadIcon />}
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                color: '#FFFFFF',
                borderRadius: '14px',
                height: '42px',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.85rem',
              }}
            >
              Download Student App
            </Button>
          </Col>

          {/* Quick links */}
          <Col xs={6} md={2} style={{ marginBottom: '24px' }}>
            <Typography variant="subtitle2" style={{ color: '#FFFFFF', fontWeight: 700, marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Explore
            </Typography>
            <Box style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <AnchorLink href={getHref("category")}>Categories</AnchorLink>
              <FooterLink to="/courses">Courses</FooterLink>
              <FooterLink to="/about">About Us</FooterLink>
              <AnchorLink href={getHref("ad")}>Achievements</AnchorLink>
            </Box>
          </Col>

          {/* Contact Details */}
          <Col xs={12} sm={6} md={3} style={{ marginBottom: '24px' }}>
            <Typography variant="subtitle2" style={{ color: '#FFFFFF', fontWeight: 700, marginBottom: '16px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Contact Us
            </Typography>
            {data.map((d, index) => (
              <Box key={index} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img src={Mail} height="20px" width="20px" alt="" style={{ opacity: 0.8 }} />
                  <Typography variant="body1" style={{ fontSize: '0.875rem' }}>{d.gmaillink}</Typography>
                </Box>
                <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <img src={Phone} height="20px" width="20px" alt="" style={{ opacity: 0.8 }} />
                  <Typography variant="body1" style={{ fontSize: '0.875rem' }}>{d.mobibleno}</Typography>
                </Box>
              </Box>
            ))}
          </Col>

          {/* Premium banner section */}
          <Col xs={12} md={3} style={{ marginBottom: '24px' }}>
            <PremiumBanner>
              <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src={Crown} alt="" height="20px" />
                <Typography variant="subtitle1" style={{ color: '#FFFFFF', fontWeight: 700 }}>
                  Premium Access
                </Typography>
              </Box>
              <Typography variant="body2" style={{ color: '#9CA3AF', lineHeight: 1.5 }}>
                Unlock high-yield mock exam series, structured subjects, model answers, and statistics trackers.
              </Typography>
              <Button
                variant="contained"
                onClick={() => Navigate("/plan")}
                style={{
                  background: 'linear-gradient(135deg, #D97706 0%, #B45309 100%)',
                  color: '#FFFFFF',
                  borderRadius: '12px',
                  height: '38px',
                  fontWeight: 700,
                  fontSize: '0.8rem',
                  boxShadow: 'none',
                }}
              >
                View Pricing Plans
              </Button>
            </PremiumBanner>
          </Col>
        </Row>

        {/* Footer Bottom Dividers & Disclaimers */}
        <Box style={{ borderTop: '1px solid #1F2937', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
          <Box style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <Typography variant="body2" style={{ fontSize: '0.75rem', color: '#6B7280' }}>
              &copy; {new Date().getFullYear()} Nursing Update. All rights reserved.
            </Typography>
            <Typography variant="body2" style={{ fontSize: '0.725rem', color: '#4B5563', maxWidth: '600px' }}>
              Disclaimer: Study materials and test series are designed for academic preparation purposes. Consult official guidelines for current professional licensing specs.
            </Typography>
          </Box>

          {/* Social media connections */}
          <Box style={{ display: 'flex', gap: '10px' }}>
            <SocialIconLink href="https://www.instagram.com/nursingupdate2023?igsh=MWx3bXkzOG1kbGR6" target="_blank" rel="noreferrer" aria-label="Instagram link">
              <img src={Insta} height="18px" alt="" />
            </SocialIconLink>
            <SocialIconLink href="https://www.facebook.com/profile.php?id=100079218203603" target="_blank" rel="noreferrer" aria-label="Facebook link">
              <img src={Facebook} height="18px" alt="" />
            </SocialIconLink>
            <SocialIconLink href="https://youtube.com/@nursingupdate-tamil?si=5kG_1oBOkE9nyJAz" target="_blank" rel="noreferrer" aria-label="YouTube link">
              <img src={YouTube} height="18px" alt="" />
            </SocialIconLink>
          </Box>
        </Box>
      </Container>
    </FooterWrapper>
  );
}
